import { __extends } from "tslib";
import { EventDispatcher } from './EventDispatcher';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: UncaughtErrorEvents
var UncaughtErrorEvents = /** @class */ (function (_super) {
    __extends(UncaughtErrorEvents, _super);
    function UncaughtErrorEvents() {
        return _super.call(this) || this;
    }
    UncaughtErrorEvents.classInitializer = null;
    UncaughtErrorEvents.classSymbols = null;
    UncaughtErrorEvents.instanceSymbols = null;
    return UncaughtErrorEvents;
}(EventDispatcher));
export { UncaughtErrorEvents };
